export const notification = {
  title: 'Push Notification',
  titleEN: 'Push Notification',
  description: 'Mackolik APP zerinden spor branşları zelinde atılan PN çalışmalarıdır. Farklı konsept ve farklı kitlelere uyarlanabilecek şekilde, kullanıcı etkileşimli kurgulardır.',
  descriptionEN: 'These are push notification (PN) campaigns sent through the Mackolik APP, focusing on different sports branches. They are user-interactive designs that can be adapted to various concepts and different audiences.',
  tabs: [
    {
      id: 1,
      title: 'Push Notification',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Devre Arası PN',
          image: 'https://srv-cdn.onedio.com/store/56d77aec4d33cb1f74e3d8d3f819eb32997183836e3b8a54d1f539a9529d3bb1.png',
          modal: 'image',
          modalTitle: 'Devre Arası - Push Notification'
        },
        {
          id: 2,
          name: 'Maçın Hakemi PN',
          image: 'https://srv-cdn.onedio.com/store/ba2638334424e4810f7ce1301dd7874eef77e6f9cd5c919368fff8c6ec79ade4.png',
          modal: 'image',
          modalTitle: 'Maçın Hakemi - Push Notification'
        },
        {
          id: 3,
          name: 'Maçtan 2 Saat Önce PN',
          image: 'https://srv-cdn.onedio.com/store/5aa9d87db9c9cd00b147964f63f3e192afa7b6c4100aff3053101a618b5504ae.png',
          modal: 'image',
          modalTitle: 'Maçtan 2 Saat Önce - Push Notification'
        },
        {
          id: 4,
          name: 'İlk 11 PN',
          image: 'https://srv-cdn.onedio.com/store/b32cdc9782fb76c85b249994117625f370bf63cbb2f75e10e4fe5d949d20623d.png',
          modal: 'image',
          modalTitle: 'İlk 11 - Push Notification'
        },
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'Push Notification',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Half-Time PN',
          image: 'https://srv-cdn.onedio.com/store/56d77aec4d33cb1f74e3d8d3f819eb32997183836e3b8a54d1f539a9529d3bb1.png',
          modal: 'image',
          modalTitle: 'Half-Time - Push Notification'
        },
        {
          id: 2,
          name: 'Referee of the match PN',
          image: 'https://srv-cdn.onedio.com/store/ba2638334424e4810f7ce1301dd7874eef77e6f9cd5c919368fff8c6ec79ade4.png',
          modal: 'image',
          modalTitle: 'Referee of the match - Push Notification'
        },
        {
          id: 3,
          name: '2 Hours Before PN',
          image: 'https://srv-cdn.onedio.com/store/5aa9d87db9c9cd00b147964f63f3e192afa7b6c4100aff3053101a618b5504ae.png',
          modal: 'image',
          modalTitle: '2 Hours Before - Push Notification'
        },
        {
          id: 4,
          name: 'Starting Lineup PN',
          image: 'https://srv-cdn.onedio.com/store/b32cdc9782fb76c85b249994117625f370bf63cbb2f75e10e4fe5d949d20623d.png',
          modal: 'image',
          modalTitle: 'Starting Lineup - Push Notification'
        },
      ]
    }
  ]
}
